<template>
  <div>
    <h5>Examen del Sistema Estomatognático</h5>
    <CommentEditor
                v-if="isAuditoria"
                field="sistemaEstomatognatico"
                :comentarios="comentarios"
                :odonto="odonto"
    />

    <b-row v-for="(fila, filaIndex) in camposEnFilas" :key="filaIndex">
      <b-col v-for="(campo, colIndex) in fila" :key="colIndex" cols="3">
        <label>{{ campo.numero }}. {{ campo.label }}</label>

        <b-form-radio-group
          v-model="estadoCampos[campo.key]"
          :options="opciones"
          buttons
          button-variant="outline-primary"
          size="sm"
          class="mb-2"
        />

        <b-form-textarea
          v-if="estadoCampos[campo.key] === 'anormal'"
          v-model="examen[campo.key]"
          rows="2"
          placeholder="Describe la observación..."
        />
      </b-col>
    </b-row>

    <!-- ✅ Texto cuando todo es normal -->
    <div v-if="todoNormal" class="text-success mt-3 font-weight-bold">
      SIN PATOLOGÍA APARENTE
    </div>
  </div>
</template>

<script>
import { BCol, BFormTextarea, BRow, BFormRadioGroup } from 'bootstrap-vue';
import CommentEditor from '../../../atencionMedica/components/CommentEditor/CommentEditor.vue';

export default {
  name: 'SistemaEstomatognatico',
  components: { BRow, BCol, BFormTextarea, BFormRadioGroup, CommentEditor },

  data() {
    return {
      odonto:true,
      comentarios:{},
      examen: {
        labios: '',
        mejillas: '',
        maxilar_superior: '',
        maxilar_inferior: '',
        lengua: '',
        paladar: '',
        piso: '',
        carrillos: '',
        glandulas_salivales: '',
        oro_faringue: '',
        a_t_m: '',
        ganglios: ''
      },

      yaInicializado: false,

      estadoCampos: {
        labios: 'normal',
        mejillas: 'normal',
        maxilar_superior: 'normal',
        maxilar_inferior: 'normal',
        lengua: 'normal',
        paladar: 'normal',
        piso: 'normal',
        carrillos: 'normal',
        glandulas_salivales: 'normal',
        oro_faringue: 'normal',
        a_t_m: 'normal',
        ganglios: 'normal'
      },

      opciones: [
        { text: 'Normal', value: 'normal' },
        { text: 'Anormal', value: 'anormal' }
      ],

      camposExamen: [
        { key: 'labios', label: 'Labios' },
        { key: 'mejillas', label: 'Mejillas' },
        { key: 'maxilar_superior', label: 'Maxilar superior' },
        { key: 'maxilar_inferior', label: 'Maxilar inferior' },
        { key: 'lengua', label: 'Lengua' },
        { key: 'paladar', label: 'Paladar' },
        { key: 'piso', label: 'Piso' },
        { key: 'carrillos', label: 'Carrillos' },
        { key: 'glandulas_salivales', label: 'Glándulas salivales' },
        { key: 'oro_faringue', label: 'Oro faringue' },
        { key: 'a_t_m', label: 'A.T.M.' },
        { key: 'ganglios', label: 'Ganglios' }
      ]
    };
  },

   props: {
    sistemaEstomatogmaticoRecibido: {
      type: Object,
      default: null
    },
       isAuditoria: {
      type: Boolean,
      default: false,
    },
  },


  computed: {
    camposEnFilas() {
      const filas = [];
      this.camposExamen.forEach((campo, index) => {
        const filaIndex = Math.floor(index / 4); // 4 columnas por fila
        if (!filas[filaIndex]) filas[filaIndex] = [];

        filas[filaIndex].push({
          ...campo,
          numero: index + 1
        });
      });
      return filas;
    },

    // ✅ Computed para verificar si todos están en estado 'normal'
    todoNormal() {
      return Object.values(this.estadoCampos).every(valor => valor === 'normal');
    }
  },

  methods: {
    emitirDatos() {
      const resultado = this.camposExamen.map(campo => ({
        campo: campo.key,
        label: campo.label,
        estado: this.estadoCampos[campo.key],
        observacion: this.estadoCampos[campo.key] === 'anormal' ? this.examen[campo.key] : ''
      }));

      this.$emit('update-sistema-estomatogmatico', {
        datos: resultado,
        sinPatologiaAparente: this.todoNormal
      });
    }
  },

  watch: {
    estadoCampos: {
      handler() {
        this.emitirDatos();

        
      },
      deep: true
    },
    examen: {
      handler() {
        this.emitirDatos();
      },
      deep: true
    },
    sistemaEstomatogmaticoRecibido: {
    handler(newValue) {
      console.log("SISTEMA ESTOMAGTONATICO", newValue)
      if (!this.yaInicializado) {
        if (newValue && Array.isArray(newValue.datos)) {
          newValue.datos.forEach(item => {
            const key = item.campo;

            if (key in this.estadoCampos) {
              this.estadoCampos[key] = item.estado;

              // Solo poner observación si es "anormal"
              if (item.estado === 'anormal') {
                this.examen[key] = item.observacion || '';
              } else {
                this.examen[key] = '';
              }
            }
          });

          this.emitirDatos(); // ✅ Emitir después de cargar los datos
          this.yaInicializado = true;
          
        } else {
          this.emitirDatos(); // ✅ Emitir por defecto si no hay datos
        }

       
      }
    },
    immediate: true,
    deep: true
  }
  }
};
</script>
